import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InvoicesService } from './services/invoices.service';
import { Organisation } from '../models/organisation';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
	selector: 'app-invoice-settings',
	templateUrl: 'invoice-settings.template.html'
})

/**
 * Component for the invoice settings page
 */
export class InvoiceSettingsComponent implements OnInit
{
	organisation: Organisation;
	errors = {};

	/**
	 * InvoiceSettingsComponent constructor
	 *
	 * @param {ActivatedRoute} route
	 * @param {Router} router
	 * @param {InvoicesService} invoicesService
	 */
	constructor(private route: ActivatedRoute, private router: Router, private invoicesService: InvoicesService)
	{
	}

	/**
	 * Lifecycle hook that is called after data-bound properties of this component are
	 * initialized.
	 */
	ngOnInit()
	{
		this.route.data.subscribe(
			(data: { organisation: Organisation }) => {
				this.organisation = data.organisation;
			}
		);
	}

	/**
	 * Save the current settings
	 *
	 * @returns void
	 */
	public saveSettings()
	{
		this.invoicesService.setInvoiceSettings(this.organisation).subscribe(
			data => {
				// Redirect to main invoices page
				this.router.navigate(['/facturen']);
			},
			err => {
				// Show errors
				if (err instanceof HttpErrorResponse) {
					this.errors = err.error.message;
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/invoice-settings.component.ts